//
//
//
//
//
//
//
//
//
//
//
//
//

import Theme from "@/listing-app/mixins/Theme";
export default {
  name: "Features",
  mixins: [Theme],
  props: ["features"]
};
